import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';

import "./Shared.css";
import "./Trade.css";

import withRouter from "./functions/withRouter";
import { existingOpenTrade, generateTradeID } from "./functions/trade";

class TradeProcess extends Component {
  constructor(props) {
    super(props);

    this.stripePromise = loadStripe("pk_live_51OKu3GBngtyIVds74A99gQACoUiynt04E33dC3SSRmvOfRHNBnhdRtH4wVvClg7q1YiPGifShV44Jb35uhVkyuWr00Uyu2DgdO");
    this.state = {error: ""};
  }

  processPayment = async () => {
    const existingTrade = await existingOpenTrade(this.props.user);

    if (existingTrade) {
      this.setState({error: "You already have an existing trade!"});
      return;
    }

    const tradeID = generateTradeID(this.props.givingBook.id, this.props.receivingBook.id);

    const price = (this.props.method === "buy") ? "price_1PIc2vBngtyIVds7OKPhdeju" : "price_1PIc2vBngtyIVds7OOPfd5le";

    const stripe = await this.stripePromise;
    const { error } = await stripe.redirectToCheckout({
      lineItems: [{
        price,
        quantity: 1,
      }],
      mode: "payment",
      clientReferenceId: tradeID,
      customerEmail: this.props.user.email,
      shippingAddressCollection: {
        allowedCountries: ["US"],
      },
      successUrl: `https://hellosincerely.com/foreword/trade/c/${this.props.method}/${this.props.givingBook.id}/${this.props.receivingBook.id}/${tradeID}/{CHECKOUT_SESSION_ID}`,
      cancelUrl: `https://hellosincerely.com/foreword/trade/start/${this.props.receivingBook.id}`,
    });

    if (error.message) {
      this.setState({error: error.message});
    }
  }

  renderMailSteps() {
    return (
      <div className="Column Margin">
        <div className="Row Margin">
          <div className="StepNumber">1</div>
          <div className="StepContent">Package up your book for sending! <span className="TextBold">Don’t forget to leave a handwritten note (a “foreword”) inside your book’s jacket for its future owner.</span> When you’re ready, mail your book to:
          <p></p>
          <div>Hello, Sincerely,</div>
          <div>93 4<sup>th</sup> Avenue #1397</div>
          <div>New York, NY 10003</div></div>
        </div>
        <div className="Row Margin">
          <div className="StepNumber">2</div>
          <div className="StepContent">This is a free service! We only ask you to cover the cost of shipping your new book. The cost of shipping is $6.</div>
        </div>
        <div className="Row Margin">
          <div className="StepNumber">3</div>
          <div className="StepContent">Once we receive your book, we’ll mail out <i>{this.props.receivingBook.title}</i> to you! Happy reading!</div>
        </div>
      </div>
    );
  }

  renderBuySteps() {
    return (
      <div className="Column Margin">
        <div className="Row Margin">
          <div className="StepNumber">1</div>
          <div className="StepContent">We’ll grab a copy of <i>{this.props.givingBook.title}</i> at our local bookstore, and make it available for others right away on the catalogue.</div>
        </div>
        <div className="Row Margin">
          <div className="StepNumber">2</div>
          <div className="StepContent">The cost is $29 for the book including shipping.</div>
        </div>
        <div className="Row Margin">
          <div className="StepNumber">3</div>
          <div className="StepContent">We’ll send you <i>{this.props.receivingBook.title}</i> right away! Delivery typically takes a week. Happy reading!</div>
        </div>
      </div>
    );
  }

  render() {
    let method = "";
    if (this.props.method === "mail") {
      method = <div className="Column Center">
        {this.renderMailSteps()}
        <div className="Button Purple TradeButton" onClick={this.processPayment}>Pay $6</div>
      </div>;
    } else if (this.props.method === "buy") {
      method = <div className="Column Center">
        {this.renderBuySteps()}
        <div className="Button Purple TradeButton" onClick={this.processPayment}>Pay $29</div>
      </div>;
    }

    if (this.state.error) {
      return (
        <div className="Content">
          <p>Error: {this.state.error}</p>
          <div className="Button Purple Margin TradeButton" onClick={this.processPayment}>Try Again</div>
          <Link to="/" replace={true}><div className="Button Margin TradeButton">Cancel</div></Link>
        </div>
      );

    } else {
      return (
        <div className="Content">
          <h1 className="HeaderText">Foreword</h1>
          <div className="TradeMargin Column Center">
            {method}
            <Link className="Button Margin TradeButton" to={`/trade/start/${this.props.receivingBook.id}`} replace={true}>Go Back</Link>
          </div>
        </div>
      );
    }
  }
}

export default withRouter(TradeProcess);
